/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate";
import { notesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import { paymentTermsStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsPaymentTerms";
import { requestedDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate";
import { shippingMethodStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod";
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus";
import { vatNumberStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsVatNumber";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const titleText: TypographyProps = {
    variant: "h5",
    as: "h2",
    css: css`
        margin-bottom: 5px;
    `,
};

export const contentText: TypographyProps = {
    size: 13,
    lineHeight: "22px",
};

orderDateStyles.wrapper = {};
orderDateStyles.titleText = titleText;
orderDateStyles.orderDate = contentText;

vatNumberStyles.titleText = titleText;
vatNumberStyles.vatNumberText = contentText;

statusStyles.wrapper = {};
statusStyles.titleText = titleText;
statusStyles.status = contentText;

shippingMethodStyles.titleText = titleText;
shippingMethodStyles.description = contentText;

requestedDateStyles.titleText = titleText;
requestedDateStyles.description = contentText;

paymentTermsStyles.titleText = titleText;
paymentTermsStyles.termsText = contentText;

notesStyles.titleText = titleText;
notesStyles.notesText = contentText;
